import { InputNumber } from "primereact/inputnumber";
import React from "react";

export default function Brojni({ initValue, changeState, auts, tipSkupaAtributaKey }) {
  const handleChange = (value) => {
    let stateArray = [
      ["initValue", tipSkupaAtributaKey, value],
      ["prikazAUTS", auts.sifra, value],
    ];
    changeState(stateArray);
  };

  return (
    <div className="d-flex">
      <InputNumber
        value={initValue !== undefined && initValue !== "" ? initValue : undefined}
        onValueChange={(e) => {
          handleChange(e.value);
        }}
        min={auts.tipAtributa && auts.tipAtributa.donjaGranicaBrojneVrednosti !== null ? auts.tipAtributa.donjaGranicaBrojneVrednosti : Number.MIN_SAFE_INTEGER}
        max={auts.tipAtributa && auts.tipAtributa.gornjaGranicaBrojneVrednosti !== null ? auts.tipAtributa.gornjaGranicaBrojneVrednosti : Number.MAX_SAFE_INTEGER}
        showButtons
        minFractionDigits={auts?.tipAtributa?.decimaleBrojneVrednosti}
        maxFractionDigits={auts?.tipAtributa?.decimaleBrojneVrednosti ?? 4}
        disabled={auts.formulaZaRacunanje}
        suffix={auts.tipAtributa && auts.tipAtributa.jedinica ? " " + auts.tipAtributa.jedinica : ""}
        placeholder={auts.tipAtributa && auts.tipAtributa.jedinica ? "    " + auts.tipAtributa.jedinica : ""}
      />
    </div>
  );
}
